import { Constants } from "../constants";
import { CalculationResultErrorTypes, ProductLines } from "../enums";
import { CalculationResult, SimulationResult } from "../models/CalculationResult";
import { NameValuePair } from "../models/NameValuePair";
import { Utilities } from "../utils/utilities";

export const generateSimulationResult = (calculationResult: CalculationResult) => {
  return {
    errorType: GetErrorType(calculationResult.errorType),
    calculatedValue: calculationResult.value,
    diagnostics: GetDiagnostics(calculationResult.diagnosticData),
    exceptionMessage: calculationResult.exceptionMessage,
  } as SimulationResult;
};

export const GetErrorType = (errorType: CalculationResultErrorTypes) => {
  switch (errorType) {
    case 0:
      return null;
    case 1:
      return "Parsing Error - Error in Script Syntax";
    case 2:
      return "Soft Error in Processing - Error in Data";
    case 3:
      return "Hard Error in Processing - Fatal Exception";
  }
};

export const GetDiagnostics = (diagnosticData: any) => {
  if (diagnosticData == null) return [];
  var returnData = [];
  var diagnosticsData = JSON.parse(diagnosticData);
  var keys = Object.keys(diagnosticsData);
  for (var key in keys)
    returnData.push({
      name: keys[key],
      value: diagnosticsData[keys[key]],
    } as NameValuePair);
  return returnData;
};

export const ProductLineSelectList = [
  ProductLines.Nitrogen,
  ProductLines.Oxygen,
  ProductLines.Helium,
  ProductLines.Hydrogen,
  ProductLines.Argon,
  ProductLines.CO2,
];

export const ConvertProductLinesListToString = (list: ProductLines[]) => {
  if (!list) {
    return "";
  }

  return list.join(Constants.Comma);
};

export const ConvertStringToProductLinesList = (plData: string) => {
  if (Utilities.isNullOrEmptyString(plData)) {
    return [];
  }

  return plData.split(Constants.Comma);
};
